import styled from "@emotion/styled";

import Link from "metabase/core/components/Link/Link";

export const ModelLinkRoot = styled(Link)`
  display: inline-flex;
  align-items: center;
  color: var(--mb-color-brand);
  font-weight: bold;
`;
